export default __webpack_public_path__ + "static/media/picture_help.7a6cd9f2.png";